/*
 * @Author: qin 15936669602@163.com
 * @Date: 2023-03-27 23:06:56
 * @LastEditors: qin 15936669602@163.com
 * @LastEditTime: 2025-08-16 21:56:19
 * @FilePath: /360-house-viewing-main/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import VueRouter from "vue-router";
import SkyBox from "../views/SkyBox.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Layout",
    component: () => import("../components/Layout/Layout.vue"),
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "Home",
        component: () => import("../views/home/index.vue"),
      },
      {
        path: "/study/:id",
        name: "Study",
        component: () => import("../views/study/index.vue"),
        meta: {
          roles: ["teacher", "admin"],
          title: "教师管理",
        },
      },
      {
        path: "/teacher",
        name: "Teacher",
        component: () => import("../views/teacher/index.vue"),
        meta: {
          roles: ["teacher", "admin"],
          title: "教师管理",
        },
      },
      {
        path: "/student-class/:id",
        name: "StudentClass",
        component: () => import("../views/student/class.vue"),
      },
      {
        path: "/student",
        name: "Student",
        component: () => import("../views/student/index.vue"),
        meta: {
          roles: ["student", "teacher", "admin"],
          title: "学生中心",
        },
      },
      {
        path: "login",
        name: "Login",
        component: () => import("../views/login/index.vue"),
      },
      {
        path: "/ai",
        redirect: "/home",
      },
      {
        path: "/help",
        name: "Help",
        component: () => import("../views/help/index.vue"),
      },
      {
        path: "/product",
        name: "Product",
        component: () => import("../views/product/index.vue"),
      },
      {
        path: "/more",
        name: "More",
        component: () => import("../views/more/index.vue"),
      },
      {
        path: "/dev",
        name: "Dev",
        component: () => import("../views/dev/index.vue"),
      },
      {
        path: "/404",
        name: "NotFound",
        component: () => import("../views/error/404.vue"),
      },
      {
        path: "/exam",
        name: "Exam",
        component: () => import("../views/exam/index.vue"),
        meta: {
          roles: ["teacher", "admin"],
          title: "考试管理",
        },
      },
    ],
  },
  {
    path: "/skyBox",
    name: "SkyBox",
    component: SkyBox,
  },
  {
    path: "*",
    redirect: "/404",
  },
];

const router = new VueRouter({
  routes,
});

export default router;
